import { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function Insights() {
  useEffect(() => {
    document.title = 'Environmental Equipment Supply Insights | Grace Wang'
  }, [])

  return (
    <div className="page">
      <section className="page-header">
        <p className="eyebrow">PRACTICAL PROJECT PREPARATION</p>
        <h1>Insights for Clearer Equipment Inquiries</h1>
        <p>Practical guidance for overseas EPC contractors, engineering companies, manufacturers and distributors.</p>
      </section>

      <section className="page-content">
        <div className="insights-grid">
          <article className="insight-card">
            <h2>Environmental Equipment Sourcing Guide</h2>
            <p>A practical, evidence-based guide to RFQ preparation, manufacturing source review, inspection documents and export coordination.</p>
            <Link to="/insights/environmental-equipment-sourcing-guide" className="link-arrow">Read More →</Link>
          </article>

          <article className="insight-card">
            <h2>Preparing an RFQ</h2>
            <p>Define application, capacity or airflow, contaminants, materials, destination and schedule before requesting a proposal.</p>
          </article>

          <article className="insight-card">
            <h2>Drawing-based fabrication</h2>
            <p>State dimensions, material requirements, interfaces, inspection documents and acceptance criteria in writing.</p>
          </article>

          <article className="insight-card">
            <h2>Clarifying the manufacturing source</h2>
            <p>Confirm whether the package is produced by the family-owned factory or a selected specialist manufacturing partner.</p>
          </article>
        </div>
      </section>
    </div>
  )
}
